/*
 * @Author: ’‘
 * @Date: 2022-04-14 10:26:36
 * @LastEditors: donsonwu
 * @LastEditTime: 2022-09-28 14:19:22
 * @FilePath: /activity_cfhd_a20220819syhact/utils.ts
 * @Description:
 */
declare function need(path: string | Array<string>, cb: Function): any
declare function g(id: string): any
declare function amsSubmit(ActId: number,giftId: number): any
import * as milo from '@tencent/milo-web'
import { amsBtn } from './AmsAndMilo/amsBtnTypeLimit'
import { plat, isPage } from './diyWork/config'

declare namespace InitShare {
  interface pcQrcodeCfg {
    width: number
    height: number
    class: string
  }
  interface classList {
    pcBtnClass?: string
    h5BtnClass?: string
    zoneBtnClass?: string
    copyBtnClass?: string
    inputValClass: string
  } 
}
declare namespace window {
  var cfhdCallbackObj: any
  var WxjssdkWx: any
  namespace location {
    var href: string
    var search: any
  }
  function open(s: string, b: string)
}

declare var GameHelper, LoginManager

function copyText(text: string, callback?: () => any): any {
  var tag = document.createElement('input')
  tag.setAttribute('id', 'cp_hgz_input')
  tag.value = text
  document.getElementsByTagName('body')[0].appendChild(tag)
  ;(document.getElementById('cp_hgz_input') as any).select()
  document.execCommand('copy')
  document.getElementById('cp_hgz_input').remove()
  if (typeof callback == 'function') {
    callback()
  } 
}

function getUrlParam(name: string) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  var r = window.location.search.substr(1).match(reg)
  if (r != null) return unescape(r[2])
  return null
}

// 是否是手Q内打开
function isQQ(): boolean {
  return / qq\//i.test(navigator.userAgent)
}
// 是否是手Q内打开
function isWX(): boolean {
  return /MicroMessenger/gi.test(navigator.userAgent)
}
function initShareFunc(pcUrl: string, h5Url: string, title: string, desc: string, summary: string, iconPic: string, pcQrcodeCfg: InitShare.pcQrcodeCfg, h5popId: string) {
  let sharePCUrl: string = pcUrl || window.location.href
  let shareMobileUrl: string = h5Url || window.location.href

  // 如果在wx和QQ的环境内，应该直接执行sth, 但是不弹窗
  if (isWX() || isQQ()) sth(shareMobileUrl, '', title, desc, iconPic)

  let shareH5 = function () {
    sth(shareMobileUrl, h5popId, title, desc, iconPic)
  }
  let shareZone = function () {
    milo.pcShare.qzoneShare.share({
      url: sharePCUrl, //分享链接[可选，不传则取页面url]
      title: title, //分享标题[可选，不传则取页面title]
      desc: desc, //分享描述[可选，不传则为空]
      pics: iconPic, //分享图片[可选，不传表示不带图片]
      summary: summary, //分享摘要[可选，不传取页面title]
      site: '来源网站', //分享来源[可选，不传则为空]
      md: 1, //1默认不允许更改  0允许更改
      callback: function (shareId) {
        //回调函数，分享成功之后执行的函数
        // alert("分享成功了,分享Id为"+shareId);
        console.log('Success Share!shareId is' + shareId)
      }
    })
    closeDialog()
  }
  var shareQQ = function () {
    var p = {
      url: shareMobileUrl,
      /*获取URL，可加上来自分享到QQ标识，方便统计*/
      desc: desc,
      /*分享理由(风格应模拟用户对话),支持多分享语随机展现（使用|分隔）*/
      title: title,
      /*分享标题(可选)*/
      summary: summary,
      pics: iconPic,
      /*分享图片(可选)*/
      flash: '',
      site: '',
      style: '201',
      width: 32,
      height: 32
    }
    var s = []
    for (var i in p) {
      s.push(i + '=' + encodeURIComponent(p[i] || ''))
    }
    window.open('//connect.qq.com/widget/shareqq/index.html?' + s.join('&'), '')
  }
  if (pcQrcodeCfg != undefined && isPage != 'H5') {
    // 二维码
    milo.loader
      .loadScript('//cfhd.cf.qq.com/cp/a20210817cfhdrlr/js/jquery.qrcode.min.js')
      .then((res) => {
        $(pcQrcodeCfg.class).empty()
        jQuery(function () {
          ;($(pcQrcodeCfg.class) as any).qrcode({
            width: pcQrcodeCfg.width,
            height: pcQrcodeCfg.height,
            text: shareMobileUrl
          })
        })
      })
      .catch((e) => console.log(e))
  }
  return {
    shareZone: shareZone,
    shareH5: shareH5,
    shareQQ: shareQQ
  }
}
function sth(url: string, popId: string, title: string, desc: string, iconPic: string) {
  var curHtmlUrl = window.location.href
  if (new RegExp('cfapp').test(navigator.userAgent) || /GameHelper/.test(navigator.userAgent) || /cfapp/.test(navigator.userAgent)) {
    launchShareWindow(url, title, desc, iconPic)
    //}else if((curHtmlUrl.indexOf("djc") >= 0 || curHtmlUrl.indexOf("props") >= 0 || curHtmlUrl.indexOf("act") >= 0 || curHtmlUrl.indexOf("daojucheng") >= 0 || curHtmlUrl.indexOf("daoju") >= 0)&&curHtmlUrl.indexOf("sEncrypt") == -1){
  } else if (isWX() || isQQ()) {
    const opts = {
      wx_appid: 'wx4a6848ac08e18340', //微信公众号appid
      title, // 分享标题，默认为活动页面标题（可手动调整）
      desc, //分享活动简介
      link: url, //分享链接
      imgUrl: iconPic, //分享后朋友看到的图标
      /*微信分享回调【不需要可不写】*/
      WXtrigger: function (res) {
        //微信点击事件回调
        //  alert("微信点击回调\n"+JSON.stringify(res));
      },
      WXsuccess: function (res) {
        //微信分享成功回调
        alert('分享成功！')
        // alert("微信分享成功回调\n"+JSON.stringify(res));
      },
      WXcancel: function (res) {
        //微信分享取消回调
        // alert("微信分享取消回调\n"+JSON.stringify(res));
      },
      WXfail: function (res) {
        //微信分享失败回调
        // alert("微信分享失败回调\n"+JSON.stringify(res));
      },

      QQcallback: function (res) {
        //qq成功、失败、或取消的回调
        // alert("QQ分享之后回调回调\n"+JSON.stringify(res));
      },
      QQtrigger: function (res) {
        //qq触发事件的回调
        // alert("QQ分享触发回调\n"+JSON.stringify(res));
      },

      qqBrowserCallback: function (data) {
        //data.code ==1 表示能分享
        //data.code ==-1 表示不能分享
        //data.code == 0 表示未知
        // alert("QQ浏览器分享触发回调\n"+JSON.stringify(data));
      }
    }
    milo.mobileShare.initShareAll(opts) // 页面初始化时调用
    TGDialogS(popId)
  } else if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
    // 手机H5端 暂时不做处理
    alert('为了您的活动体验，请前往手机QQ或者微信参加~')
  }
}

function launchShareWindow(url, title, desc, iconPic) {
  var title = title,
    desc = desc,
    icon = iconPic
  if (typeof GameHelper != 'undefined') {
    GameHelper.shareWebPageWithFuntion(title, desc, icon, url, '1,2,3,4,5', 1)
  } else {
    //zhtc();

    var comment_info = desc
    var share_url = url
    var title = title
    var summary = desc
    var icon = iconPic
    var collect_state = 1

    //掌上cf分享ios需要的函数
    var sendIosMessage = function (src) {
      var oIFrame: any = document.getElementById('__MessageIframe__')
      if (!oIFrame) {
        oIFrame = document.createElement('iframe')
        oIFrame.id = '__MessageIframe__'
        oIFrame.frameborder = '0'
        oIFrame.scrolling = 'no'
        oIFrame.width = '0px'
        oIFrame.height = '0px'
        oIFrame.frameBorder = '0'
        oIFrame.style.display = 'none'
        oIFrame.src = src
        document.body.appendChild(oIFrame)
      } else {
        oIFrame.src = src
      }
    }

    //掌上cf分享安卓需要的函数
    var sendAndroidMessage = function (src) {
      window.location.href = src
    }

    var data = {
      title: encodeURIComponent(title),
      summary: encodeURIComponent(summary),
      icon: encodeURIComponent(icon),
      is_act: encodeURIComponent('1'),
      url: encodeURIComponent(share_url),
      collect_state: encodeURIComponent(collect_state)
      //"shareopen" : encodeURIComponent("1")
    }
    var src = 'requestapp://sharenew?param=' + encodeURIComponent(JSON.stringify(data))
    if (new RegExp('cfapp').test(navigator.userAgent)) {
      if (new RegExp('Android').test(navigator.userAgent)) {
        sendAndroidMessage(src)
      } else {
        sendIosMessage(src)
      }
    }
  }
}
function bindShare(pcUrl:string,shareBtn:InitShare.classList,shareInfoObj:any){
  $(shareBtn.pcBtnClass).click(function(){shareInfoObj.shareQQ()})
  $(shareBtn.zoneBtnClass).click(function(){shareInfoObj.shareZone()})
  $(shareBtn.h5BtnClass).click(function(){shareInfoObj.shareH5()})
  $(shareBtn.inputValClass).val(pcUrl)
  $(shareBtn.copyBtnClass).click(function(){copyText(pcUrl,milo.miloAlert("复制成功~"))})
  
}

function handleGiftCount(list) {
  list.map(function (ele) {
    // console.log(ele.sPackageName)
    // console.log(!ele.sPackageName.search(/\*[0-9]/))
    if (parseInt(ele.iPackageNum) > 1 && ele.sPackageName.search(/\*/) < 0) {
      ele.sPackageName += '*' + ele.iPackageNum
    }
  })
  return list
}

// 礼包记录 传入 ams的流程id   和  绑定函数的 dom 
export function giftRecord(ActId: number, giftId: number) { 
  const tmp = `<div class="milo-dialog" id="myGiftlist_dialog_${giftId}" style="display:none">
    <div class="milo-dialog-mask"></div>
    <div class="milo-dialog-content">
        <div class="milo-mygiftlist-dialog">
            <div class="milo-mygiftlist-dialog-header">
                <div>信息提示</div>
                <i class="milo-mygiftlist-close-btn" id="myGiftlist_dialog_close_${giftId}"></i>
            </div>
            <div class="milo-mygiftlist-dialog-content">
                <div class="tips"><strong>温馨提示</strong>：虚拟道具奖品将在24小时内发到您的游戏内仓库，请耐心等候，谢谢您的理解与支持！</div>
                <table>
                    <thead>
                        <tr>
                            <th style="width:33%">获奖时间</th>
          
                            <th style="width:34%">所获礼包</th>
                            <th style="width:33%">礼包数量</th>
                            
                        </tr>
                    </thead>
                    <tbody id="myGiftlist_tbody_${giftId}">
        
                    </tbody>
                    <tfoot id="myGiftlist_footer_${giftId}" class="pagination">
        
                    </tfoot>
                </table>
            </div>
        </div>          
    </div>
  </div>`
  const style = `
  <style>
  .milo-mygiftlist-dialog {
    width: 600px;
    background-color: #fff;
    z-index: 1000;
 }
 
 .milo-mygiftlist-dialog  .milo-mygiftlist-dialog-header {
    width: 100%;
    background: url(https://ossweb-img.qq.com/images/gamevip/act/act_comm/lz_top_spr_v2.png) repeat-x 0 -97px;
    height: 36px;
    line-height: 36px;
    margin: 0px;
    color: #fff;
    padding: 0 20px;
    position: relative;
    box-sizing: border-box;
 }
 
 .milo-mygiftlist-dialog  .milo-mygiftlist-dialog-header .milo-mygiftlist-close-btn {
    position: absolute;
    right: 0;
    top: 0;
    margin: 10px 10px 0 0;
    width: 14px;
    height: 13px;
    text-indent: -999em;
    overflow: hidden;
    background: url(https://ossweb-img.qq.com/images/gamevip/act/act_comm/lz_top_spr_v2.png) no-repeat -297px -5px;
 }
 
 .milo-mygiftlist-dialog-content {
    padding: 20px;
 }
 .milo-mygiftlist-dialog-content table {
    width: 100%;
    border-collapse:collapse;
 }
 
 .milo-mygiftlist-dialog-content .tips {
    font-size: 12px;
 }
 .milo-mygiftlist-dialog-content table th{
    border: 1px solid #e8e8e8;
    padding: 4px 2px;
    width: 33.3%;
    text-align: center;
    font-weight: normal;
    background: #efefef;
 }
 .milo-mygiftlist-dialog-content table td {
    height: 28px;
    line-height: 28px;
    text-align: center;
    background: #fff;
    color: #000;
    border: 1px solid #e8e8e8;
 }
 .milo-mygiftlist-dialog-content .pagination {
      background: #efefef;
      text-align: center
 }
 .milo-mygiftlist-dialog-content .pagination .page {
     border:none;
 }
 
 .milo-mygiftlist-dialog-mobile {
    width: 300px;
    max-height: 600px;
    overflow: scroll;
    background-color: #fff;
    z-index: 1000;
 }
 .milo-mygiftlist-dialog-mobile  .milo-mygiftlist-dialog-header {
    width: 100%;
    background: url(https://ossweb-img.qq.com/images/gamevip/act/act_comm/lz_top_spr_v2.png) repeat-x 0 -97px;
    height: 30px;
    line-height: 30px;
    margin: 0px;
    color: #fff;
    padding: 0 10px;
    position: relative;
    box-sizing: border-box;
 }
 .milo-mygiftlist-dialog-mobile  .milo-mygiftlist-dialog-header .milo-mygiftlist-close-btn {
    position: absolute;
    right: 0;
    top: 0;
    margin: 10px 10px 0 0;
    width: 14px;
    height: 13px;
    text-indent: -999em;
    overflow: hidden;
    background: url(https://ossweb-img.qq.com/images/gamevip/act/act_comm/lz_top_spr_v2.png) no-repeat -297px -5px;
 }
 .milo-mygiftlist-dialog-mobile .milo-mygiftlist-dialog-content {
    padding: 10px;
 }
 .milo-mygiftlist-dialog-mobile .milo-mygiftlist-dialog-content table {
    width: 100%;
    font-size: 14px;
    border-collapse:collapse;
 }
 </style>`
  $('body').after(style)
  $('script:last').after(tmp)

  milo.MyGiftList.init({
    plat: plat,
    iActivityId: ActId,
    iFlowId: giftId,
    flowConfig: {
      everyUpdate: true,
      pageSize: '5',
      pageNow: 1
    },
    tableBodyRender: (list) => {
      const getStatus = (giftInfo) => {
        if (giftInfo.iStatus == '0') {
          return '成功'
        }
        if (!giftInfo.itemList) {
          return '发货中'
        } else {
          return giftInfo.itemList
            .map((item) => {
              if (item.iItemStatus == '0') {
                return `<span style="color:green;">${item.sItemName}(${item.iItemNum}) 已发货 </span><br>`
              } else {
                return `<span style="color:#aaa;">${item.sItemName}(${item.iItemNum}) 发货中 </span><br> `
              }
            })
            .join('')
        }
      }
      if (list && list.length) {
        return list
          .map((giftInfo) => {
            return `
                <tr>
                  <td>${giftInfo.getTime}</td>
                  <td>${giftInfo.packageName}</td>
                  <td>${giftInfo.iPackageNum}</td>
              <!-- <td>${getStatus(giftInfo)}</td>-->
                </tr>
              `
          }).join('')
      } else {
        return `
          <tr>
            <td colspan="4" align="center">您尚未获得任何礼包</td>
          </tr>
        `
      }
    }
    // tableFooterRender:tableFooterRender,
  }).then((mygiftlist) => {
    mygiftlist.showDialog()
  })
}
// 礼包记录 传入 ams的流程id   和  绑定函数的 dom
export function realGoodGift(ActId: number, giftId: number) {
    
    const tmp = `<a href="###" id="fillPersonInfo_${giftId}">填写个人信息</a>
                  <div id="shipAddress_${giftId}" style="display:none;">
                  <div class="gift-ship-address-dialog-mask"></div>
                  <div class="gift-ship-address-dialog-container">
                      <div class="gift-ship-address-dialog-header">
                      实物中奖个人信息
                      <a href="###" class="close-btn close-dialog">关闭</a>
                      </div>
                      <p class="hint">个人信息填写:为保证实物奖励能准确邮寄，下面所有项目务必详细填写！<span>未获得实物奖励请勿填写</span></p>
                      <form id="shipAddress_form_${giftId}" class="content">   
                          <div  class= "line">
                              <label class="must">所获实物</label>
                              <div class="form-item"><select name="sPackageInfo" id="package_${giftId}"></select></div>
                          </div>
                          <div class= "line">
                              <label class="must">姓名</label>
                              <div class="form-item"><input name="sName" type="text" class="input-box"/></div>
                          </div>
                          <div class= "line">
                              <label class="must">身份证</label> 
                              <div class="form-item"><input name="sIdentity" type="text" class="input-box"></div>
                          </div>
                          <div class= "line">
                              <label class="must">手机</label> 
                              <div class="form-item"><input name="sMobile" type="text" class="input-box"></div>
                          </div>
                          <div class= "line">
                              <label class="must">省份</label>
                              <div class="form-item"><select name="sProvince" id="province_${giftId}" type="text"></select></div>
                          </div>
                          <div class= "line">
                              <label class="must">城市</label>
                              <div class="form-item"><select name="sCity" id="city_${giftId}" type="text"></select></div>
                          </div>
                          <div class= "line">
                              <label>区/县</label>
                              <div class="form-item"><select name="sExtend2" id="county_${giftId}" type="text"></select></div>
                          </div>
                          <div class= "line">
                              <label class="must">详细地址</label>
                              <div class="form-item"><input name="sAddress" type="text" class="input-box"></div>
                          </div>
                          <div class= "line">
                              <label >邮编</label>
                              <div class="form-item"><input name="sPostCode" type="text" class="input-box"></div>
                          </div>
                          <div class= "line order-line">
                              <label>发货订单</label>
                              <div id="order_${giftId}" class="order-info">暂无</div>
                          </div>
                          <div style="text-align: center;color: #fff;font-size: 14px;">奖励将在活动结束后的3个月内发货</div>
                          <div class='btn-container'>
                              <a id="submitBtn_${giftId}" class='btn submit-btn'>提交</a>
                              <a class='btn cancel-btn close-dialog'>取消</a>
                          </div>    
                      </form>
                  </div>
                </div>`

  if($('#fillPersonInfo_'+giftId).length==0){
    $('script:last').after(tmp)  
  }
  
  milo.ShipAddress.init({
      plat: plat,
      iActivityId: ActId,
      iFlowId: giftId,
  }).then(shipaddress => {
      shipaddress.query((res)=>{
          console.log(res)
      }, (err) => {
          console.log(err)
      })
  })
  
}

function btnGray(zigeNum, ele, grayClassName) {
  var maxCount = parseInt(ele.maxCount) || 1
  var className = ele.grayClass || ele.class
  if (parseInt(zigeNum) === maxCount) {
		$(className).addClass(grayClassName)    
    if(ele.btnStr){
      if(ele.btnStr == 1){
        $(className).text("")
      }else{
        $(className).text(ele.btnStr)
      }
    }else{
		  $(className).text('已领取')
    }
	}

}

function btnGrayNormalHandle(cfhdCallbackObj, btnClassList, grayClassName) {
  btnClassList &&
    btnClassList.forEach(function (ele) {
      if (cfhdCallbackObj[ele.key] && !ele.notNeedGray) {
        btnGray(cfhdCallbackObj[ele.key].split(',')[ele.postion], ele, grayClassName)
      }
    })
}


function teamInfo(teamParams,fid){
  //注==这里没有聚宝盆个人积分的处理 全部为数据库数据处理
	var teamInfoArr = teamParams.teamInfo.split('||');
	var userTeamInfo = teamInfoArr[0].split(',');//个人及团队信息
	if (userTeamInfo[0] != '0') {
		// 有队伍
		$(teamParams.joinClass).css('display', 'block');
		$(teamParams.notJoinClass).hide();
		$(teamParams.teamIdClass).val(userTeamInfo[0]);//团队ID
		// 点过推荐按钮 或者  bu是队长
		if (parseInt(userTeamInfo[1]) == 1 || parseInt(userTeamInfo[5]) !== 1) {
          $(teamParams.tjBtnClass).hide();
        }
		$(teamParams.teamCountClass).text(userTeamInfo[2]);//团队人数
		//注==积分部分需要商量一下 是直接传入积分显示位置的class 还是强行使用积分名当做class 如果需要传入class 需要考虑初始化数组中增加字段
    pageDataChange(userTeamInfo[3]+","+userTeamInfo[6],[teamParams.teamLevelJfName,teamParams.peopleLevelJfName])
		if(teamParams.jbpTeamLevelJfName!=""){
      pageDataChange(userTeamInfo[4]+","+userTeamInfo[7],[teamParams.jbpTeamLevelJfName,teamParams.jbpPeopleLevelJfName])
		}
	}else{
		// 没队伍
        $(teamParams.notJoinClass).show();
        $(teamParams.joinClass).hide();
	}
	//推荐团
	var teamList = teamInfoArr[1].split(',');
  var domstr = '' 
	teamList.forEach(function (ele) {
		if (ele != '') {
		  var team = ele.split('|');
      domstr += '<tr><td>' + team[0] + '</td><td>' + team[1] + '</td></tr>'
      /**if(teamParams.joinClass == '.tab8_team'){
        domstr += '<tr><td>' + team[0] + '</td><td>' + team[1] + '</td></tr>'
      }else{
        domstr += '<tr><td>' + team[0] + '</td><td>' + team[1] + '</td><td><a href="javascript:joinTeam(\'' + team[0] + '\','+fid+')">点击加入</a></td></tr>'
      }**/
		}
	})
	$(teamParams.tjTeamListClass).empty();
	$(teamParams.tjTeamListClass).append(domstr);
	return userTeamInfo[0];
}
function changeJf(key,num,type,jfMap){
  if (jfMap.get(key) != undefined) {
      if(type=='='){
          jfMap.set(key, num);
      }else if(type=='+'){
          jfMap.set(key, jfMap.get(key) + num);
      }else{
          jfMap.set(key, jfMap.get(key) - num);
      }
  $("."+key).text(jfMap.get(key));
  }
}


function pageDataChange(pageDataStr:string,pagePosition:Array<string>){
    const pageDataArr = pageDataStr.split(',');
    pageDataArr.forEach((ele,index) => {
      $("."+pagePosition[index]).text(ele);
    })

}

function request(url, method) {
  return new Promise((resolve, reject) => {
    // 获取 XMLHttpRequest 对象的实例
    const xhr = new XMLHttpRequest()
    xhr.overrideMimeType('text/html;charset=gb2312')
    xhr.open(method, url)
    xhr.send(null)
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        /**
         * http 状态码在 200 的区间都是请求成功的状态
         * 状态码 304 表示缓存文件
         */
        if ((xhr.status >= 200 && xhr.status < 300) || xhr.status === 304) {
          // console.log(xhr)
          const template = xhr.responseText
          resolve(template)
        } else {
          console.log('request was unsuccessful:' + xhr.status)
          reject('fail')
        }
      }
    }
  })
}

function loadScript(url, charset = 'gbk') {
  return new Promise((resolve, reject) => {
    let _script = document.createElement('script')
    _script.setAttribute('charset', charset)
    _script.setAttribute('type', 'text/javascript')
    _script.setAttribute('src', url)
    document.getElementsByTagName('head')[0].appendChild(_script)

    var timeout = setTimeout(() => {
      reject('timeout') //rejected
    }, 5000)

    _script.onload = () => {
      //加载完成
      clearTimeout(timeout)
      resolve('') //fulfilled
    }
    _script.onerror = () => {
      //加载失败
      reject('fail') //rejected
    }
  })
}
function loadStyle(url) {
  return new Promise((resolve, reject) => {
    let _style = document.createElement('style')
    // _style.setAttribute('charset', 'utf-8')
    // rel="stylesheet"
    _style.setAttribute('rel', 'stylesheet')
    _style.setAttribute('href', url)
    document.getElementsByTagName('head')[0].appendChild(_style)

    var timeout = setTimeout(() => {
      reject('timeout') //rejected
    }, 5000)

    _style.onload = () => {
      //加载完成
      clearTimeout(timeout)
      resolve('') //fulfilled
    }
    _style.onerror = () => {
      //加载失败
      reject('pull fail') //rejected
    }
  })
}

function loadTab({ container, html, js, jsCharSet, css = '' }) {
  if ((window as any).powerByMicroPageTab1) {
    console.log('已经加载过啦~')
  } else {
    ;(window as any).powerByMicroPageTab1 = true
    request(html, 'get').then((tpl: any) => {
      $(container).empty()
      $(container).append(tpl)
      // console.log(tpl)
      loadScript(js, jsCharSet)
      if (css) {
        loadStyle(css)
      }
    })
  }
}
function TGDialogS(id){
  if ($('#'+id).length <= 0) {
    console.log(`弹窗id有误${id}`)
    return
  }
  // 隐藏上一次的弹窗
  $('.tgdia-class').hide()
  var $dom = $('#'+id).show()
  // 获取缩放前的宽高
  var h = $dom[0].offsetHeight/2
  var w = $dom[0].offsetWidth/2
  // 需要pop的元素加上style
  $dom.attr('style', `position:fixed;left:50%;top:50%; margin-top:${-h}px;margin-left: ${-w}px;z-index:1002;display:block;`)
  // 增加标识
  $dom.addClass('tgdia-class')
  // 蒙版弹窗
  var template = `<div class="tgdialog-main" onclick="closeDialog()" style="width: 100%;height:${$('body').css('height')};background: rgba(0,0,0,0.5);position: absolute;top: 0px;left:0;z-index:1001"></div>`
  // <div class="tgdialog-content" style="position:fixed;left:50%;top:${$(window).height()/2}px; transform: translate(${-w}px, ${-h}px);z-index:1002">${t}</div>
  //蒙版贴上去并且打开
  $('.tgdialog-main').show()
  $('body').append(template)
  //stopPageScroll()
}
function closeDialog() {
  // 删除蒙版，隐藏所有弹窗
  $('.tgdialog-main').remove()
  $('.tgdia-class').hide()
  //startPageScroll()
}
function getCFArea(ele: amsBtn) {
  if ((window as any).CFbind.CFareaidsure != 0) {
    ;(window as any)[`sData${ele.class}`].area = (window as any).CFbind.CFareaidsure
    return true
  } else {
    (window as any).CFbind.initbind()
    return false
  }
}
function startPageScroll() {
  $('html').css('height','0%')
  $('html').css('overflow','auto')
}
function stopPageScroll() {
  $('html').css('height','100%')
  $('html').css('overflow','hidden')
}
const channelIdArr = {
  'index':767,
  'pc':767,
  'neiqian':767,
  'nq':767,
  'm':769,
  'h5':769,
  'mzh':769,
  'wg':767,

  'hy':12,
  'djc':19,
  'gj':15,
  'llq':77,
  'xy':21,
  'txjsq':16,
  'yyx':78,
  'wegame':14,
  'wegames':14,

  'hyh5':12,
  'djch5':19,

  'cfmwx':79,
  'cfmqq':80,

  'wx':10,
  'sq':11,
  'yyb':17,

  'wxxcx':81,
  'sqxcx':82,


  'hw':70,
  'vivo':74,
  'oppo':73,

  'haoyou4399':71,

  'yys':83,
  'beiyong':766,
  'interbarcm':767,
  'bdtbcm':767,
  'shunwang':767,
  'shunwang1':767,
  'ygx':767

  };

  function getchannelCode(position:number){
    let urlInfo = window.location.href.split('/');
	  let urlArr = urlInfo[position].split('.');
	  let Channelid = channelIdArr[urlArr[0]]
    return Channelid;
  }

  function nomsg(ele){

  }

  //比较时间
  function compare (date) {
    const today = new Date()
    const comVal = new Date(date)
    return today >= comVal
  }

  function weekPop(lefttype){
    //向页面填加样式 
    if(lefttype==0){
      var newElement = document.createElement("style"); 
      newElement.innerHTML = "#tabinframe{left:0 !important}"
      document.head.appendChild(newElement);
    }
    
    var curUrl = window.location.href; // 取得当前页面的地址
    var index = curUrl.indexOf("?"); 
    if (index != -1) {
      curUrl = curUrl.substring(0, index); // 截取掉查询参数
    }
    //官网特殊处理
    if(curUrl=='https://cfhd.cf.qq.com/'){
      const actNameAndPageType = curUrl+'_0';
      if(typeof((window as any).weekUrlArrNew[actNameAndPageType])=='string'){
        let popUrl = (window as any).weekUrlArrNew[actNameAndPageType].split('/');
        setTimeout(function () {
            $('#tabinframe2_'+popUrl[4]).attr('src', (window as any).weekUrlArrNew[actNameAndPageType]);
        }, 200);
      }
    }else{
      //活动地址分割后查找是否存在配置
      let urlInfo = curUrl.split('/');
      const actNameAndPageType = urlInfo[4]+'_'+isPage+'_0';
      if(typeof((window as any).weekUrlArrNew[actNameAndPageType])=='string'){
        let popUrl = (window as any).weekUrlArrNew[actNameAndPageType].split('/');
        setTimeout(function () {
          $('#tabinframe2_'+popUrl[4]).attr('src', (window as any).weekUrlArrNew[actNameAndPageType]);
        }, 200);
      }
    }
    
  }

// 工具函数暴露到全局中
;(window as any).TGDialogS = TGDialogS
;(window as any).closeDialog = closeDialog

export { getUrlParam, copyText, btnGrayNormalHandle, loadTab, isWX, sth, isQQ, TGDialogS,teamInfo,pageDataChange,initShareFunc,bindShare,getCFArea,getchannelCode,nomsg,closeDialog,compare,weekPop}

